export const monitoring = {

  index: {
    title: 'Мониторинг кампании'
  },

  operators: {
    topic: 'Операторы',
    count_active: 'Активно',
    count_connected: 'Подключено',
    state: {
      disconnected: 'Отключен',
      connected: 'Активен'
    },
    disconnected: {
      state: 'Отключены'
    },
    connected: {
      state: 'Подключены'
    }
  },

  rooms: {
    topic: 'Комнаты',
    empty: 'Комната пустая, скоро исчезнет',
    state: {
      ready: 'Готов к работе',
      busy: 'Идет разговор',
      pending: 'Оператор отключился',
      empty: 'Пустая комната'
    }
  },

  tasks: {
    topic: 'Задачи',
    all: 'Всего',
    pending: {
      state: 'В ожидании'
    },
    connected: {
      state: 'Ожидание оператора'
    },
    dialing: {
      state: 'Набор номера'
    },
    active: {
      state: 'Разговор'
    },
    processing: {
      state: 'Обработка'
    },
    canceled: {
      state: 'Отменена'
    },
    checking: {
      state: 'Проверка автоответчика'
    }
  },

  campaign: {
    topic: 'Информация о кампании',
    type: 'Тип',
    avg_task: 'Средняя продолжительность задачи'
  },

  field: {
    id: 'ID',
    number: 'Номер',
    caller_id: 'Caller ID',
    priority: 'Приоритет',
    attempts: 'Кол-во попыток',
    strategy: 'Положение в стратегии',
    start: 'Дата создания заказа',
    status: 'Статус',
    campaign: 'кампанию',
    avg_time: 'Среднее время дозвона',
    sec: 'сек',
    calc: 'ASR',
    login: 'Логин',
    drop: 'Сбросить ASR',
    last_attempt: 'Последняя попытка',
    next_attempt: 'Следующая попытка',
    created_at: 'Дата создания заказа',
    lead_date: 'Дата создания задачи'
  },
  
  state: {
    title: 'Статус',
    success: 'Успешно',
    processing: 'В процессе',
    canceled: 'Отменена',
    pending: 'В ожидании',
    fail: 'Неуспешно'
  },

  button: {
    create: 'Мониторинг'
  },

  type: {
    progressive: 'Прогрессивный',
    predictive: 'Предиктивный'
  },

  modal: {
    create: 'Создание задачи'
  }
}